import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function getStudentAssignments(studentId) {
  if (!studentId) return [];

  const q = query(
    collection(db, "users", studentId, "assignments"),
    orderBy("assignedAt", "desc")
  );

  const snap = await getDocs(q);

  return snap.docs.map((doc) => {
    const d = doc.data();

    return {
      id: doc.id,
      category: d.section ?? "",
      title: d.packetName ?? "",
      subtitle: `${d.questionCount ?? 0} Questions`,
      assignedDate: d.assignedAt?.toDate?.().toLocaleDateString() ?? "",
      lastSavedAt: d.lastSavedAt ?? null,
      status:
        d.status === "completed"
          ? "Complete"
          : d.status === "in_progress"
          ? "In Progress"
          : "Not Attempted",
      correct: d.correct ?? 0,
      incorrect:
        d.questionCount != null && d.correct != null
          ? d.questionCount - d.correct
          : 0,
      reviewMode: d.status === "completed",
      simpleView: false,
    };
  });
}
